import { gql } from '@apollo/client';

const changeDateRequestEditEventReviewNotificationFragment = gql`
  fragment ChangeDateRequestEditEventReviewNotificationFields on EventChangeDateRequestEditEventReviewNotification {
    EventId
  }
`;

export default changeDateRequestEditEventReviewNotificationFragment;
